import { useContext, useEffect, useState } from "react";
import { Table, Row, Col, DatePicker } from "antd";

import moment from "moment";

import { Context } from "../../context";
import { Fetch } from "../../fetch";
import { convertIdToKey } from "../../utils";

const { Column } = Table;

const dateFormat = "YYYY-MM-DD";

const ResellerReports = () => {
  const { token, apiUrl } = useContext(Context);

  const [filters, setFilters] = useState({
    date: [moment().startOf("month"), moment().endOf("month")],
    activeSubscription: null,
  });

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [resellers, setResellers] = useState([]);

  useState(() => {
    if (resellers.length !== 0) {
      return;
    }
    Fetch(`${apiUrl}/resellers`, token, (result) => {
      if (result) {
        const reseller = convertIdToKey(result.resellers);
        setResellers(reseller);
      }
    });
  }, [apiUrl, token]);

  useEffect(() => {
    setLoading(true);
    const startDate = moment(filters.date[0]).isValid()
      ? moment(filters.date[0]).format(dateFormat)
      : null;
    const endDate = moment(filters.date[1]).isValid()
      ? moment(filters.date[1]).format(dateFormat)
      : null;
    Fetch(
      `${apiUrl}/reports/reseller_reports?start_date=${startDate}&end_date=${endDate}`,
      token,
      (result) => {
        if (result.success === true) {
          const subscriptions = convertIdToKey(result.data);
          setData(subscriptions);
          setLoading(false);
        } else {
          setLoading(false);
        }
      }
    );
  }, [apiUrl, token, filters]);

  const getResellerName = (resellerId) => {
    if (resellerId === "jio") return "JIO";
    const reseller = resellers.find((e) => e.key === resellerId);
    return reseller && reseller.name ? reseller.name : "N/A";
  };

  return (
    <div className="manage-orders-wrapper">
      <Row>
        <Col span={6}>
          <DatePicker.RangePicker
            format={dateFormat}
            defaultValue={filters.date}
            allowClear={false}
            onChange={(_, dateString) => {
              setFilters({
                ...filters,
                date: dateString ? dateString : [null, null],
              });
            }}
          />
        </Col>
      </Row>
      <br></br>
      <Table dataSource={data} loading={loading}>
        <Column title="Reseller Plan" align="center" dataIndex={"plan"} />
        <Column
          title="Reseller Name"
          align="center"
          dataIndex={"reseller"}
          render={(_, record) => getResellerName(record.reseller)}
        />
        <Column
          title="Subscriptions"
          align="center"
          dataIndex={"subscriptions"}
        />
      </Table>
    </div>
  );
};

export default ResellerReports;
